import React, { useEffect, useState } from "react";
import { Table, Select, Button, Modal, Form, Row, Col, Input, message, Alert, Flex, Card, Space, Typography, Popconfirm } from "antd";
import AxiosService from "../services/APIService";
import { CloseOutlined, EditOutlined, FilterOutlined } from "@ant-design/icons";
import useBroker from "../hooks/useBroker";
import useServer from "../hooks/useServer";
import { connect } from "react-redux";
import useCustomer from "../hooks/useCustomer";
import { Link } from "react-router-dom";
import { downloadFileHandle } from "../utils/commonFunc";
const { Option } = Select;
function PendingUser({ permission, user, isLoading }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const axiosService = new AxiosService();
  const [userList, setUserList] = useState();
  const { brokerList } = useBroker();
  const { serverList } = useServer();
  const [editData, seteditData] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const { customerList } = useCustomer({});
  const [activeKey, setActiveKey] = useState("pending");

  const columns = [
    {
      title: "#",
      dataIndex: "count",
      key: "count",
      width: "50px",
    },
    {
      title: "Bot Id",
      dataIndex: "cutId",
      key: "custId",
      width: "100px",
    },
    {
      title: "Account Name",
      dataIndex: "name",
      key: "name",
      render: (e, rec) => <Link to={`/user-profile?userId=${rec.key}`}>{e}</Link>,
    },
    {
      title: "Reference By",
      dataIndex: "reference",
      key: "reference",
    },
    {
      title: "IB Name",
      dataIndex: "ibName",
      key: "ibName",
    },
    {
      title: "Broker",
      dataIndex: "broker",
      key: "broker",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (e, rec) =>
        (permission?.customer == "EDIT" || user?.role != "SUBADMIN") && (
          <Select
            defaultValue={e}
            value={e}
            disabled={!rec.action.account_number}
            onChange={(val) => statusChange(val, rec)}
            options={[
              { value: "PENDING", label: "Pending" },
              { value: "CREATED", label: "Create" },
              { value: "RESOLVED", label: "Resolved" },
            ]}
          />
        ),
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      render: (e, rec) =>
        (permission?.customer == "EDIT" || user?.role != "SUBADMIN") && (
          <Space>
            {user?.role !== "WHITE_LABEL" && <Button type="default" icon={<EditOutlined />} size={"middle"} onClick={() => editOpen(e)} />}
            <Popconfirm
              description="Are you sure you want to delete this account?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => deleteCustomer(rec.key)}
            >
              <Button icon={<CloseOutlined />} danger size={"middle"} />
            </Popconfirm>
          </Space>
        ),
    },
  ];
  
  if (activeKey === "rejected") {
  columns.splice(6, 0, {
    title: "Reject Reason",
    dataIndex: "reject_reason",
    key: "reject_reason",
  });
}
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  useEffect(() => {
    fetchPendingUser({});
  }, [activeKey]);

  const deleteCustomer = (id) => {
    axiosService
      .delete(`/customer/delete-customer/${id}`)
      .then((res) => {
        fetchPendingUser({});
        message.success(res.message);
      })
      .catch((e) => {
        message.error(e.message);
      });
  };

  const statusChange = (val, rec) => {
    axiosService
      .post(`/customer/change-status/${rec?.key}`, {
        status: val,
      })
      .then((res) => {
        message.success(res.message);
        fetchPendingUser({});
      })
      .catch((e) => message.error(e.message));
  };

  const editOpen = (val) => {
    form.setFieldValue("brokerName", val?.broker_name);
    form.setFieldValue("brokerName_wl", val?.broker_wl);
    form.setFieldValue("accountNumber", val?.account_number);
    form.setFieldValue("masterPassword", val?.master_password);
    form.setFieldValue("investorPassword", val?.investor_password);
    form.setFieldValue("portalLink", val?.portal_link);
    form.setFieldValue("portalPassword", val?.portal_password);
    form.setFieldValue("brokerServer", val?.server);
    form.setFieldValue("vpsServer", val?.server_vps?._id);
    seteditData(val._id);
    setIsModalOpen(true);
  };

  const fetchPendingUser = (params) => {
    axiosService
      .get("/customer/list", {
        status: activeKey === "rejected" ? `["REJECTED"]` : `["PENDING", "RESOLVED"]`,
        ...params,
      })
      .then((res) => {
        const data = res.data.map((dt, i) => ({
          key: dt._id,
          count: i + 1,
          cutId: dt?.cust_code,
          name: `${dt?.user?.preference || ""} ${dt?.user?.fullName}`,
          reference: dt?.reference_by?.fullName || "-",
          broker: dt?.broker ? `${dt?.broker?.name}` : dt?.broker_wl ? dt?.broker_wl : "-",
          ibName: dt?.broker ? `${dt?.broker?.ib_name}` : "-",
          status: dt?.status,
          action: dt,
          reject_reason: dt?.reject_reason
        }));
        setUserList(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleOk = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const formSubmit = (val) => {
    const formData = new FormData();

    if (val?.brokerName) formData.append("broker_name", val?.brokerName);
    if (val?.broker_wl) formData.append("broker_wl", val?.brokerName_wl);
    formData.append("account_number", val?.accountNumber);
    formData.append("master_password", val?.masterPassword);
    formData.append("investor_password", val?.investorPassword);
    formData.append("portal_link", val?.portalLink);
    formData.append("portal_password", val?.portalPassword);
    formData.append("server", val?.brokerServer);
    if (val?.vpsServer) formData.append("server_vps", val?.vpsServer);

    axiosService
      .put(`/customer/admin-update/${editData}`, formData)
      .then((res) => {
        message.success(res.message);
        handleOk();
        fetchPendingUser({});
        seteditData("");
      })
      .catch((e) => message.error(e.message));
  };
  const filterData = (key) => {
    return userList.filter((dt) => dt.name.toLowerCase().includes(key.toLowerCase()) || dt.cutId.toLowerCase().includes(key.toLowerCase()));
  };
  const filterHandle = (val) => {
    fetchPendingUser(val);
  };
  const resetFilter = () => {
    form1.resetFields();
    fetchPendingUser({});
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
  };
  return (
    <>
      <Modal title="Update User" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} width={1000}>
        <Form form={form} layout="vertical" onFinish={formSubmit} initialValues={editData}>
          <Row gutter={16}>
            <Col span={12}>
              {user?.role === "WHITE_LABEL" ? (
                <Form.Item label="Company name" name="brokerName_wl" rules={[{ required: true, message: "Please Enter Company name!" }]}>
                  <Input placeholder="Enter Company name" />
                </Form.Item>
              ) : (
                <Form.Item label="Company name" name="brokerName" rules={[{ required: true, message: "Please Enter Company name!" }]}>
                  {/* <Select placeholder="Select Broker" options={brokerList.map(brk => ({
                                    value: brk._id,
                                    label: brk.name
                                }))}>
                                    {brokerList.map(bkr => <Select.Option key={bkr._id} value={bkr._id}>{bkr.name}</Select.Option>)}
                                </Select> */}

                  <Input size="large" placeholder="Enter Broker Name" />
                </Form.Item>
              )}
            </Col>
            <Col span={12}>
              <Form.Item label="Account Number" name="accountNumber" rules={[{ required: true, message: "Please Enter account number!" }]}>
                <Input placeholder="Enter Account Number" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Master Password" name="masterPassword" rules={[{ required: true, message: "Please Enter master password!" }]}>
                <Input.Password placeholder="Enter Master Password" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Investor Password" name="investorPassword" rules={[{ required: true, message: "Please Enter investor password!" }]}>
                <Input.Password placeholder="Enter Investor Password" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Portal Link" name="portalLink" rules={[{ required: true, message: "Please Enter portal link!" }]}>
                <Input placeholder="Enter Portal Link" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Password (Portal)" name="portalPassword" rules={[{ required: true, message: "Please Enter portal password!" }]}>
                <Input.Password placeholder="Enter Portal Password" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Server (Broker)" name="brokerServer" rules={[{ required: true, message: "Please Enter broker server!" }]}>
                <Input placeholder="Enter Broker Server" />
              </Form.Item>
            </Col>
            {user?.role !== "WHITE_LABEL" && (
              <Col span={12}>
                <Form.Item label="Vps Server" name="vpsServer" rules={[{ required: true, message: "Please select VPS server!" }]}>
                  <Select
                    placeholder="Select Vps Server"
                    showSearch
                    options={serverList.map((srvr) => ({
                      value: srvr._id,
                      label: srvr.vps_ip,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option?.value?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
          <Button loading={isLoading} type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </Modal>
      <Typography.Title level={3} className="page-title">
        {activeKey === "pending" ? "Pending Users" : "Rejected User"}
      </Typography.Title>
      <div style={{ display: "flex", justifyContent: "space-between", paddingTop:"20px" }}>
        <Flex justify="start" gap={5} style={{ marginBottom: "20px" }}>
          <div className="tabs" style={{ display: "flex", gap: 12 }}>
            {[
              { key: "pending", label: "Pending User" },
              { key: "rejected", label: "Rejected User" },
            ].map((tab) => (
              <div
                key={tab.key}
                onClick={() => handleTabChange(tab.key)}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  background: activeKey === tab.key ? "#bffe66" : "#fff",
                  border: "1px solid #e8e8e8",
                  cursor: "pointer",
                  fontWeight: 500,
                  color: activeKey === tab.key ? "#000" : "rgba(0, 0, 0, 0.85)",
                  transition: "all 0.3s ease",
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </Flex>
        <div style={{ display: "flex", gap: "12px" }}>
          <Input style={{ maxWidth: 250, maxHeight:"34px" }} placeholder="Search by Bot Id / Account Name..." onChange={(e) => setSearchText(e.target.value)} />
          <Button type="primary" onClick={() => setFilterShow(!filterShow)}>
            <FilterOutlined />
          </Button>
          <Button type="primary" onClick={() => downloadFileHandle(userList, "pending_users")}>
            Download
          </Button>
        </div>
      </div>
      {filterShow && (
        <Card style={{ marginBottom: "20px" }}>
          <Form form={form1} layout="vertical" onFinish={filterHandle}>
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item name="refName">
                  <Select
                    placeholder="Select Reference"
                    allowClear
                    showSearch
                    options={customerList.map((cst) => ({
                      value: cst?.user?._id,
                      label: cst?.user?.fullName,
                    }))}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                {/* <Form.Item name="brokerName">
                                <Select allowClear placeholder="Select Broker">
                                    {brokerList.map(bkr => <Option key={bkr._id} value={bkr._id}>{bkr.name}</Option>)}
                                </Select>
                            </Form.Item> */}
              </Col>
              <Col span={4}>
                <Form.Item name="ibName">
                  <Select allowClear placeholder="Select IB">
                    {[...new Set(brokerList.map((item) => item.ib_name))].map((bkr) => (
                      <Option key={bkr} value={bkr}>
                        {bkr}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col>
                <Space>
                  <Button type="primary" htmlType="submit" loading={isLoading}>
                    Filter
                  </Button>
                  <Button type="default" onClick={resetFilter}>
                    Reset
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Card>
      )}
      {permission?.customer == "EDIT" || permission?.customer == "VIEW" || user?.role != "SUBADMIN" ? (
        <Table loading={isLoading} columns={columns} dataSource={searchText ? filterData(searchText) : userList} />
      ) : (
        <Alert message="You havn't Enough Permission" />
      )}
    </>
  );
}
const mapStateToProps = ({ login, loading }) => {
  const { permission, user } = login;
  const { isLoading } = loading;
  return { permission, user, isLoading };
};
export default connect(mapStateToProps, {})(PendingUser);
